import React, { useEffect } from 'react';
import useApiTranslation from '../../hooks/useApiTranslation';
import i18n from '../../i18n';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, contactName }) => {
  const { triggerTranslation } = useApiTranslation(isOpen, { selector: '#delete-confirmation-modal', enabled: isOpen, delay: 50 });
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => triggerTranslation('#delete-confirmation-modal'), 0);
    }
  }, [isOpen, triggerTranslation]);
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div id="delete-confirmation-modal" className="bg-white rounded-lg shadow-lg max-w-md w-full">
        <div className="p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-4">
            {i18n.t('Delete Contact', { ns: 'static' })}
          </h3>
          <p className="text-gray-600 mb-6">
            {i18n.t('Are you sure you want to delete "{name}"? This action cannot be undone.', { ns: 'static' }).replace('{name}', contactName)}
          </p>
          
          <div className="flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              {i18n.t('Cancel', { ns: 'static' })}
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
            >
              {i18n.t('Delete', { ns: 'static' })}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal; 